<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="kreditgenie-text-green hover:kreditgenie-text-green-hover" :href="route('influencers')">Dokuments</inertia-link>
      <span class="kreditgenie-text-green font-medium">/</span> Erschaffen
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <select-input v-model="form.type" label="Typ" class="w-full lg:w-1/3">
            <option v-for="docType in docTypes()" :key="docType.key" :value="docType.key">
              {{ docType.value }}
            </option>
          </select-input>
        </div>
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <textarea-input
            v-model="form.text"
            :error="form.errors.text"
            class="pr-6 pb-0 mb-0 w-full lg:w-full"
            label="Texte"
            rows="15"
          />
          <small class="pb-8 pt-2">(tags wie <b>[gender]</b>, <b>[first_name]</b>, <b>[last_name]</b> und <b>[credit_amount]</b> werden ersetzt)</small>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-green" type="submit">Erschaffen</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '../../Shared/SelectInput.vue'
import {docTypes} from './docTypes'
import TextareaInput from '../../Shared/TextareaInput.vue'

export default {
  metaInfo: { title: 'Dockument Erschaffen' },
  components: {
    TextareaInput,
    SelectInput,
    LoadingButton,
  },
  layout: Layout,
  props: {
    tinyMceApiKey: String,
  },
  remember: 'form',
  data() {
    return {
      editor: null,
      form: this.$inertia.form({
        'type': null,
        'text': null,
      }),
    }
  },
  methods: {
    docTypes() {
      return docTypes
    },
    store() {
      this.form.post(this.route('documents.store').url())
    },
  },
}
</script>

